"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemWithKpiAlert = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var DashboardItemKpi_1 = require("../DashboardItem/DashboardItemKpi");
var filterUtils_1 = require("./utils/filterUtils");
// adapted from jQuery:
// https://github.com/jquery/jquery/blob/a503c691dc06c59acdafef6e54eca2613c6e4032/src/offset.js#L83-L97
function getNodeDocumentRelativeOffsetTop(node) {
    var _a;
    // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
    // Support: IE <=11+
    // Running getBoundingClientRect on a
    // disconnected node in IE throws an error
    if (!node.getClientRects().length) {
        return 0;
    }
    // Get document-relative position by adding viewport scroll to viewport-relative gBCR
    var rect = node.getBoundingClientRect();
    var win = node.ownerDocument.defaultView;
    return rect.top + ((_a = win === null || win === void 0 ? void 0 : win.pageYOffset) !== null && _a !== void 0 ? _a : 0);
}
var DashboardItemWithKpiAlert = /** @class */ (function (_super) {
    tslib_1.__extends(DashboardItemWithKpiAlert, _super);
    function DashboardItemWithKpiAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeouts = {};
        _this.isScrolledToHighlightedAlert = false;
        _this.node = react_1.default.createRef();
        _this.state = {
            isKpiAlertAfterSaving: false,
            isKpiAlertAfterDeleting: false,
            isAlertHighlighted: false,
        };
        _this.renderAlertBox = function () {
            var isAlertingTemporarilyDisabled = filterUtils_1.isAlertingTemporarilyDisabledForGivenFilter(_this.props.kpi, _this.props.filters, _this.props.userWorkspaceSettings);
            var alertIconClasses = classnames_1.default("dash-item-action", "dash-item-action-alert", "s-dash-item-action-alert", "gd-icon-bell", {
                "alert-set": _this.state.isKpiAlertAfterSaving,
                "alert-deleted": _this.state.isKpiAlertAfterDeleting,
            });
            // TODO: Remove "isAlertingTemporarilyDisabledForGivenFilter" when alerts support absolute filters (RAIL-1456, RAIL-1457).
            //       When alert is set, we allow opening the alert box so user can edit/delete it.
            if (_this.props.isReadOnlyMode ||
                !_this.props.canSetAlert ||
                (isAlertingTemporarilyDisabled && !_this.props.alert)) {
                var bubbleMessage = _this.props.isReadOnlyMode ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpi.alertBox.disabledInReadOnly" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: !isAlertingTemporarilyDisabled
                        ? "kpi.alertBox.unverifiedEmail"
                        : "visualization.alert_not_supported" }));
                return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0, tagName: "div", className: classnames_1.default(alertIconClasses, "disabled") },
                    react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] }, bubbleMessage)));
            }
            return (react_1.default.createElement("div", { onClick: _this.onAlertDialogOpenClick },
                react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: alertIconClasses, showDelay: 500, hideDelay: 0, tagName: "div" },
                    react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "tc bc" }, { align: "tc br" }] },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpi.alertBox.title" })))));
        };
        _this.onAlertDialogOpenClick = function (e) {
            e.stopPropagation();
            _this.props.onAlertDialogOpenClick();
        };
        return _this;
    }
    DashboardItemWithKpiAlert.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.isKpiAlertSaved(nextProps)) {
            this.updateStatePropertyForTime("isKpiAlertAfterSaving", 1000);
        }
        if (this.isKpiAlertDeleted(nextProps)) {
            this.updateStatePropertyForTime("isKpiAlertAfterDeleting", 1000);
        }
        if (!this.props.isAlertHighlighted && nextProps.isAlertHighlighted) {
            this.updateStatePropertyForTime("isAlertHighlighted", 5000);
        }
    };
    DashboardItemWithKpiAlert.prototype.componentDidUpdate = function () {
        if (this.props.isAlertHighlighted && !this.isScrolledToHighlightedAlert) {
            this.isScrolledToHighlightedAlert = true;
            var node = this.node.current;
            if (node) {
                window.scrollTo(0, getNodeDocumentRelativeOffsetTop(node));
            }
        }
    };
    DashboardItemWithKpiAlert.prototype.componentWillUnmount = function () {
        this.clearUpdatingTimeout();
    };
    // toggle property to true for given amount of time
    DashboardItemWithKpiAlert.prototype.updateStatePropertyForTime = function (name, timeout) {
        var _a;
        var _this = this;
        var _b = this.state, isKpiAlertAfterSaving = _b.isKpiAlertAfterSaving, isKpiAlertAfterDeleting = _b.isKpiAlertAfterDeleting, isAlertHighlighted = _b.isAlertHighlighted;
        this.clearUpdatingTimeout(name);
        this.setState((_a = {
                isKpiAlertAfterSaving: isKpiAlertAfterSaving,
                isKpiAlertAfterDeleting: isKpiAlertAfterDeleting,
                isAlertHighlighted: isAlertHighlighted
            },
            _a[name] = true,
            _a));
        this.timeouts[name] = setTimeout(function () {
            var _a;
            _this.setState((_a = {
                    isKpiAlertAfterSaving: isKpiAlertAfterSaving,
                    isKpiAlertAfterDeleting: isKpiAlertAfterDeleting,
                    isAlertHighlighted: isAlertHighlighted
                },
                _a[name] = false,
                _a));
        }, timeout);
    };
    DashboardItemWithKpiAlert.prototype.clearUpdatingTimeout = function (name) {
        var _this = this;
        if (name && this.timeouts[name]) {
            clearTimeout(this.timeouts[name]);
            delete this.timeouts[name];
        }
        else {
            Object.keys(this.timeouts).forEach(function (key) { return clearTimeout(_this.timeouts[key]); });
            this.timeouts = {};
        }
    };
    DashboardItemWithKpiAlert.prototype.isKpiAlertSaved = function (nextProps) {
        return (!this.state.isKpiAlertAfterSaving &&
            this.props.alertSavingStatus === "inProgress" &&
            nextProps.alertSavingStatus === "idle");
    };
    DashboardItemWithKpiAlert.prototype.isKpiAlertDeleted = function (nextProps) {
        return (!this.state.isKpiAlertAfterDeleting &&
            this.props.alertDeletingStatus === "inProgress" &&
            nextProps.alertDeletingStatus === "idle");
    };
    DashboardItemWithKpiAlert.prototype.getClassNames = function () {
        var _a;
        var kpiAlertResult = this.props.kpiAlertResult;
        var isNoData = sdk_ui_1.isNoDataSdkError(this.props.alertExecutionError);
        var hasEvaluationResult = isNoData || (kpiAlertResult === null || kpiAlertResult === void 0 ? void 0 : kpiAlertResult.measureResult) !== undefined;
        var content = classnames_1.default(this.props.contentClassName, {
            "is-alert-dialog": this.props.isAlertDialogOpen,
            "has-set-alert": !!this.props.alert,
            "is-alert-triggered": hasEvaluationResult && ((_a = this.props.alert) === null || _a === void 0 ? void 0 : _a.isTriggered) && !this.props.suppressAlertTriggered,
            "is-alert-broken": hasEvaluationResult && this.props.isAlertBroken,
            "is-alert-highlighted": this.state.isAlertHighlighted,
            "is-alert-evaluating": this.props.isAlertExecutionLoading,
        });
        var kpi = classnames_1.default(this.props.kpiClassName, "s-dashboard-kpi-component", "widget-loaded", "visualization", {
            "kpi-with-pop": this.props.kpi.kpi.comparisonType !== "none",
            "content-loading": this.props.isLoading,
            "content-loaded": !this.props.isLoading,
        });
        return {
            content: content,
            kpi: kpi,
        };
    };
    DashboardItemWithKpiAlert.prototype.render = function () {
        var _this = this;
        var classnames = this.getClassNames();
        return (react_1.default.createElement(DashboardItemKpi_1.DashboardItemKpi, { contentClassName: classnames.content, visualizationClassName: classnames.kpi, contentRef: this.node, renderAfterContent: function () { return _this.props.isAlertDialogOpen && _this.props.renderAlertDialog(); }, renderHeadline: function (clientHeight) { return (react_1.default.createElement(react_1.default.Fragment, null,
                _this.renderAlertBox(),
                _this.props.renderHeadline(clientHeight))); } }, this.props.children));
    };
    DashboardItemWithKpiAlert.defaultProps = {
        isAlertHighlighted: false,
        filters: [],
        alertDeletingStatus: "idle",
        alertSavingStatus: "idle",
        alertUpdatingStatus: "idle",
        suppressAlertTriggered: false,
        isReadOnlyMode: false,
    };
    return DashboardItemWithKpiAlert;
}(react_1.Component));
exports.DashboardItemWithKpiAlert = DashboardItemWithKpiAlert;
//# sourceMappingURL=DashboardItemWithKpiAlert.js.map